// components/todos/TodoCreateModal.jsx
import { useState, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function TodoCreateModal({
    open,
    onClose,
    onCreate,             // async ({ title }) => Promise<void>
    pending = false,
    error = null,
}) {
    const [title, setTitle] = useState("");

    useEffect(() => {
        if (open) setTitle(""); // 열릴 때 초기화
    }, [open]);

    if (!open) return null;

    const canSubmit = title.trim().length > 0 && !pending;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!canSubmit) return;
        await onCreate?.({ title: title.trim() });
    };

    return (
        <div
            role="dialog"
            aria-modal="true"
            className="fixed inset-0 z-50 flex items-center justify-center"
        >
            <div className="absolute inset-0 bg-black/30" onClick={onClose} />

            <form
                onSubmit={handleSubmit}
                className="
                    relative 
                    w-[92vw] max-w-[720px]       
                    md:max-w-[550px]             
                    rounded-lg bg-white shadow-xl
                    p-4 md:p-6
                    max-h-[85vh] overflow-y-auto  
                "
            >
                {/* Header */}
                <div className="relative flex items-center justify-center mb-4">
                    <h2 className="absolute left-1/2 -translate-x-1/2 text-xl md:text-2xl font-bold">
                        오늘의 할 일 추가
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="닫기"
                        className="ml-auto p-1 rounded-md active:scale-95"
                    >
                        <XMarkIcon className="w-7 h-7 text-gray-500" />
                    </button>
                </div>

                {/* Field */}
                <label className="block text-base md:text-lg mb-1">기록 내용</label>
                <input
                    autoFocus
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="내용을 입력해주세요."
                    className="w-full rounded-lg border border-gray-200 px-3 py-2 outline-none focus:ring-2 focus:ring-[#5F9BFF] text-base md:text-lg"
                />

                {/* Error */}
                {error && (
                    <p className="mt-2 text-sm text-red-500">{String(error)}</p>
                )}

                {/* Submit */}
                <button
                    type="submit"
                    disabled={!canSubmit}
                    className={`mt-4 w-full rounded-lg px-4 py-2.5 text-white text-base md:text-lg
                    ${canSubmit ? "bg-[#5F9BFF] hover:brightness-95 active:scale-[.99]" : "bg-[#5F9BFF]/60 cursor-not-allowed"}
                `}
                >
                    {pending ? "추가 중..." : "내용 추가"}
                </button>
            </form>
        </div>
    );
}
